/* ══════════════════════════════════════════════════════════════
   VYROXE full-page 3D depth — loaded on EVERY page via theme.liquid
   1. Specular glare that follows the pointer across [data-tilt] cards
   2. Scroll-velocity 3D lean on product grids
   3. Gentle hover tilt for [data-tilt] cards outside the homepage
      (homepage cards are tilted by the home section's own script)
   Layer pop-out in Z is handled in vyroxe-3d.css.
   Fails silent: no [data-tilt] on a page = nothing happens.
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;

  /* ── 1. Glare follows the pointer ── */
  var cards = document.querySelectorAll('[data-tilt]');
  cards.forEach(function (card) {
    if (!card.querySelector(':scope > .vx-glare')) {
      var glare = document.createElement('div');
      glare.className = 'vx-glare';
      glare.setAttribute('aria-hidden', 'true');
      card.appendChild(glare);
    }
  });
  function setGlare(card, clientX, clientY) {
    var r = card.getBoundingClientRect();
    if (!r.width || !r.height) return;
    card.style.setProperty('--gx', (((clientX - r.left) / r.width) * 100).toFixed(1) + '%');
    card.style.setProperty('--gy', (((clientY - r.top) / r.height) * 100).toFixed(1) + '%');
  }
  if (!isTouch) {
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) { setGlare(card, e.clientX, e.clientY); }, { passive: true });
    });
  } else {
    document.addEventListener('touchstart', function (e) {
      var t = e.target.closest ? e.target.closest('[data-tilt]') : null;
      if (t && e.touches.length) setGlare(t, e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
  }

  /* ── 2. Grids lean in 3D with scroll velocity ── */
  var grids = document.querySelectorAll('.main-grid, .products-grid, .product-grid');
  if (grids.length && !isTouch) {
    var lastY = window.scrollY, vel = 0, raf = null;
    function settle() {
      raf = null;
      var lean = Math.max(-3.2, Math.min(3.2, vel * 0.05));
      for (var k = 0; k < grids.length; k++) {
        grids[k].style.transform = 'rotateX(' + lean.toFixed(2) + 'deg)';
      }
      vel *= 0.88;
      if (Math.abs(vel) > 0.06) {
        raf = requestAnimationFrame(settle);
      } else {
        for (var m = 0; m < grids.length; m++) grids[m].style.transform = '';
      }
    }
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      vel = y - lastY;
      lastY = y;
      if (!raf) raf = requestAnimationFrame(settle);
    }, { passive: true });
  }

  /* ── 3. Hover tilt for [data-tilt] cards outside the homepage ── */
  if (!isTouch) {
    cards.forEach(function (card) {
      if (card.closest('#vyroxe-root')) return; // homepage tilt is handled by the home section script
      var rafId = null, rect = null, curRX = 0, curRY = 0, tgtRX = 0, tgtRY = 0;
      function anim() {
        curRX += (tgtRX - curRX) * 0.14;
        curRY += (tgtRY - curRY) * 0.14;
        card.style.transform = 'perspective(1100px) rotateX(' + curRX.toFixed(2) + 'deg) rotateY(' + curRY.toFixed(2) + 'deg)';
        if (Math.abs(tgtRX - curRX) > 0.01 || Math.abs(tgtRY - curRY) > 0.01) {
          rafId = requestAnimationFrame(anim);
        } else {
          rafId = null;
        }
      }
      function kick() { if (!rafId) rafId = requestAnimationFrame(anim); }
      card.addEventListener('mouseenter', function () { rect = card.getBoundingClientRect(); });
      card.addEventListener('mousemove', function (e) {
        if (!rect) rect = card.getBoundingClientRect();
        tgtRX = ((e.clientY - rect.top - rect.height / 2) / (rect.height / 2)) * -4;
        tgtRY = ((e.clientX - rect.left - rect.width / 2) / (rect.width / 2)) * 4;
        kick();
      });
      card.addEventListener('mouseleave', function () { rect = null; tgtRX = 0; tgtRY = 0; kick(); });
    });
  }
})();
